<template>
  <div class="d-flex justify-content-center mt-4 mb-2">
    <div class="loader"/>
  </div>
</template>

<script>
export default {
  name: 'LoadingContent'
}
</script>